

export class PoiTypeStatusStatusInput implements IPoiTypeStatusStatusInput {
    /** The auto-generated id of the poi type master */
    poiTypeId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IPoiTypeStatusStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiTypeId = _data["poiTypeId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiTypeStatusStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeStatusStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiTypeId"] = this.poiTypeId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiTypeStatusStatusInput {
    /** The auto-generated id of the poi type master */
    poiTypeId: number;
    /** The updated status */
    status: number;
}

